import $ from 'jquery';
import Config from '../utils/config';
import { createCustomEvent, getFullUrlPath } from '../utils/common';

const actStatus = Config.appConfig.ActStatus;

function MessageStore() {
    const eventTarget = document.createElement('div');
    let intervalId = 0;
    let subscriberNumber = 0;
    let privateMessage = Config.appConfig.LastTopPrivateNews ? Config.appConfig.LastTopPrivateNews : '';
    let privateMessageCount = 0;

    function getPrivateInfo() {
        if (actStatus !== '2') {
            return {};
        }

        return { privateMessage, privateMessageCount };
    }

    function setPrivateInfo(data) {
        privateMessageCount = data.Count;
        privateMessage = data.Message;
        eventTarget.dispatchEvent(createCustomEvent('privateMessageUpdate'));
    }

    function readPrivateMessage() {
        privateMessageCount = 0;
        eventTarget.dispatchEvent(createCustomEvent('privateMessageUpdate'));
    }
    
    function subscribePrivateInfo(callback) {
        if (actStatus !== '2') {
            return;
        }

        subscriberNumber++;
        if (subscriberNumber === 1) { // if somebody start to subscribe private message
            getPrivateMessage().then(setPrivateInfo);
            intervalId = setInterval(() => {
                getPrivateMessage().then(setPrivateInfo);
            }, 60 * 1000);
        }

        eventTarget.addEventListener('privateMessageUpdate', callback);
    }
    
    function unSubscribePrivateInfo(callback) {
        if (actStatus !== '2') {
            return;
        }

        if (subscriberNumber <= 0) {
            return;
        }

        subscriberNumber--;
        if(subscriberNumber === 0) { // if nobody subscribe private message
            clearInterval(intervalId);
        }

        eventTarget.removeEventListener('privateMessageUpdate', callback);
    }

    async function getPrivateMessage() {
        return await getMessage('false');
    }

    async function getMessage(isPublic) {
        return await Promise.resolve($.ajax({
            url: getFullUrlPath('getMSG.ashx'),
            cache: false,
            data: { ispublic: isPublic, sPricount: privateMessageCount },
            dataType: 'json'
        }));
    }

    return Object.freeze({
        subscribePrivateInfo,
        unSubscribePrivateInfo,
        getPrivateInfo,
        readPrivateMessage
    });
}

export default MessageStore();
